import React, { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import TagsInput from 'react-tagsinput'
import './react-tagsinput.css'
import { CButton, CCard } from '@coreui/react'
import './content.scss'
import { getCountriesAction } from '../../../Redux/Actions/userAction'
import {
  concatDateTimeToIso,
  getThumbnail,
  isEmpty,
  masterAndChildIntersection,
} from '../../utils/helper'
import { getMetaData } from '../../../Redux/Actions/metaDataAction'
import CustomMetadata from 'src/components/CustomMetadata/CustomMetadata'
import useAxios from 'axios-hooks'
import { CONTENT_RATING_API, USER_API } from '../../utils/urls'
import CustomMultiSelect from 'src/components/customMultiSelect/customMultiSelect'
import CustomAccordion from 'src/components/customAccordion/customAccordion'
import Select from 'react-select'
import { GlobalContext } from 'src/views/context/GlobalState'
import ImageNotFound from '../../../assets/image-not-found.jpg'
import CustomMultiSelectValues from 'src/components/customMultiSelect/customMultiSelectValues'
import DatePicker from 'react-date-picker'
import DateIcon from 'src/assets/Content-Icons/dateicon'
import TimePicker from 'src/components/timePicker/timePicker'
import { AppContext } from 'src/views/context/app'

const Setting = (props) => {
  const { toggleValue, isEdit, details, cancelModal } = props
  const dispatch = useDispatch()
  const { userSessionObj } = useContext(GlobalContext)
  const { accountObj } = useContext(AppContext)
  const [rating, setRating] = useState({
    value: '',
    label: '',
  })
  const [ratingMaster, setRatingMaster] = useState([])
  const [tags, setTags] = useState([])
  const [geoBlockCountries, setGeoBlockCountries] = useState([])
  const [countries, setCountries] = useState([])
  const [customMetadataMaster, setCustomMetadataMaster] = useState([])
  const [customMetadata, setCustomMetadata] = useState({})
  const [contentPartnerMaster, setContentPartnerMaster] = useState([])
  const [contentPartner, setContentPartner] = useState([])
  const [errorData, setErrorData] = useState({})
  const [releaseDate, setReleaseDate] = useState('')
  const [releaseTime, setReleaseTime] = useState(
    new Date().toLocaleTimeString('en-UK', { timeStyle: 'short', hour12: false }),
  )

  const [{ data: contentRatingList }, contentRatingCall] = useAxios(
    {
      url: CONTENT_RATING_API,
      method: 'get',
    },
    { manual: true },
  )
  const [{ data: contentPartnerList }, contentPartnerListCall] = useAxios(
    {
      url: `${USER_API}/content-partner`,
      method: 'get',
    },
    { manual: true },
  )

  let isGeoBlockAllowed = accountObj?.od_resource_allowances?.geo_block

  useEffect(() => {
    if (isEdit && !isEmpty(details)) {
      const tempTag = details?.search_tags ? details['search_tags'] : []
      setCustomMetadata(details?.custom_metadata)
      setTags(tempTag)
      setGeoBlockCountries(
        details?.is_geo_block_enabled && details?.geo_block_countries
          ? details?.geo_block_countries
          : [],
      )

      if (details?.content_rating) {
        let isRatingActive = !isEmpty(
          masterAndChildIntersection(ratingMaster, [details?.content_rating]),
        )
        setRating(
          isRatingActive
            ? {
                value: details['content_rating']?._id,
                label: (
                  <div className="d-flex">
                    <img
                      style={{ width: '15px', height: '15px' }}
                      alt="rating"
                      src={getThumbnail(
                        userSessionObj.session_data.cf_domain_name,
                        details['content_rating']?.icon?.s3_key,
                      )}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null // prevents looping
                        currentTarget.src = ImageNotFound
                      }}
                      className="mx-1"
                    />
                    <span style={{ fontSize: '12px' }} className="d-flex align-items-center">
                      {details['content_rating']?.name}
                    </span>
                  </div>
                ),
              }
            : {},
        )
      }

      let tempOwner = []
      details.owner.forEach((partnerId) => {
        const partnerObj = contentPartnerMaster.find((info) => info._id === partnerId)
        if (partnerObj) {
          tempOwner.push(partnerObj)
        }
        // if (userObj._id !== ele._id) {
        // }
      })
      setContentPartner(masterAndChildIntersection(contentPartnerMaster, tempOwner))
      if (details?.release_time) {
        setReleaseDate(new Date(details?.release_time + 'Z'))
        setReleaseTime(
          new Date(details['release_time'] + 'Z').toLocaleTimeString('en-UK', {
            timeStyle: 'short',
            hour12: false,
          }),
        )
      }
    }
  }, [isEdit, details])

  useEffect(() => {
    getCountries()
    getCustomMetadataList()
    contentRatingCall()
    contentPartnerListCall()
  }, [])

  useEffect(() => {
    if (contentRatingList && contentRatingList.success) {
      setRatingMaster(contentRatingList.data.filter((item) => item.status))
    }
  }, [contentRatingList])

  useEffect(() => {
    if (contentPartnerList && contentPartnerList.success) {
      let tempPartner = []
      contentPartnerList.data.forEach((element) => {
        let obj = element
        obj[`displayName`] = `${element.name}(${element.email_id})`
        tempPartner.push(obj)
      })
      setContentPartnerMaster(tempPartner.filter((info) => info.status))
    }
  }, [contentPartnerList])

  const handleChange = (tag) => {
    setTags(tag)
  }

  const getCountries = async () => {
    const res = await dispatch(getCountriesAction())
    if (res?.success) {
      setCountries(res.data)
    }
  }

  const getCustomMetadataList = async () => {
    const res = await dispatch(getMetaData('custom'))
    if (res?.success) {
      const meta = res.data.filter((item) => item.status && item.entity_type === 'content')
      setCustomMetadataMaster(meta)
    }
  }

  const handleClearError = (field) => {
    if (errorData && errorData[field]) {
      errorData[field] = ''
    }
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSave = () => {
    if (validateInfo()) {
      dispatch({
        type: 'ADVANCE_SETTING',
        payload: {
          customMetadata: customMetadata,
          tags: tags,
          rating: rating?.value ? ratingMaster.find((item) => item._id === rating.value) : '',
          geoBlocking: geoBlockCountries.length > 0 ? true : false,
          geoBlockCountries: geoBlockCountries,
          owner: !isEmpty(contentPartner) ? contentPartner.map((info) => info._id) : [],
          release_time: releaseDate ? concatDateTimeToIso(releaseDate, releaseTime) : '',
        },
      })
      toggleValue(5)
    }
  }

  const getRatingOptions = () => {
    return ratingMaster.map((info) => ({
      value: info?._id,
      label: (
        <div className="d-flex">
          <img
            style={{ width: '15px', height: '15px' }}
            alt="rating"
            src={getThumbnail(userSessionObj.session_data.cf_domain_name, info?.icon?.s3_key)}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null // prevents looping
              currentTarget.src = ImageNotFound
            }}
            className="mx-1"
          />
          <span style={{ fontSize: '12px' }} className="d-flex align-items-center">
            {info?.name}
          </span>
        </div>
      ),
    }))
  }

  let accordionItems = [
    {
      title: 'ADVANCED  METADATA',
      description:
        'Please be sure that appropriate custom Metadata settings has done for the asset. Otherwise go to the Metadata for more asset settings.',
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5', padding: '0.8rem 5rem 2rem 1rem' }}
          className=" d-flex flex-column justify-content-center align-items-center"
        >
          <div
            className=" d-flex justify-content-between w-100 flex-wrap"
            style={{ gap: '1.75rem 4.4vw' }}
          >
            <div className="" style={{ width: '49%' }}>
              <h6 style={{ fontSize: '0.85vw' }} className="text-left">
                Search Tag{' '}
                <span style={{ fontWeight: '400', marginLeft: '.75rem', fontSize: '12px' }}>
                  (Input Text and Press Enter to add a Tag)
                </span>
              </h6>
              <div className="text-left">
                <TagsInput
                  value={tags}
                  onChange={(tag) => {
                    handleClearError('tags')
                    handleChange(tag)
                  }}
                />
                <div className="message-text error-message">
                  <p>{errorData.tags}</p>
                </div>
              </div>
            </div>
            {isGeoBlockAllowed && (
              <div className="" style={{ width: '36%' }}>
                <h6 style={{ fontSize: '0.85vw' }} className="text-left">
                  Geo-Blocking{' '}
                  <span style={{ fontWeight: '400', marginLeft: '.75rem', fontSize: '12px' }}>
                    (Publish your content only to Specific Countries)
                  </span>
                </h6>
                <div>
                  <CustomMultiSelect
                    selectedValue={geoBlockCountries}
                    optionsData={!isEmpty(countries) ? countries : []}
                    onChange={setGeoBlockCountries}
                    labelKey="name"
                    valueKey="iso2"
                  />
                  <div className="message-text error-message">
                    <p>{errorData.geoBlockCountries}</p>
                  </div>
                </div>
              </div>
            )}
            <div className="" style={{ width: '49%' }}>
              <h6 style={{ fontSize: '0.85vw' }} className="text-left">
                Content Rating
              </h6>
              <div>
                <Select
                  value={rating}
                  onChange={setRating}
                  options={getRatingOptions()}
                  isSearchable={false}
                  styles={{ height: '30px' }}
                />
              </div>
            </div>
            <div className="" style={{ width: '36%' }}>
              <h6 style={{ fontSize: '0.85vw' }} className="text-left">
                Release Date
              </h6>
              <div className="d-flex">
                <div>
                  <DatePicker
                    className="date-picker-pricing"
                    onChange={setReleaseDate}
                    value={releaseDate}
                    calendarIcon={<DateIcon />}
                    format="dd/MM/y"
                  />
                </div>
                <div style={{ marginLeft: '1.5vw', position: 'relative' }}>
                  <TimePicker time={releaseTime} setTime={setReleaseTime} />
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
      itemStyle: '',
      accordionHeight: '4.6875vw',
      accordionPaddingRight: '1.5rem',
    },
    {
      title: 'CUSTOM  METADATA',
      description:
        'Please be sure that appropriate custom Metadata settings has done for the asset. Otherwise go to the Metadata for more asset settings.',
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5' }}
          className=" px-4 py-3 d-flex flex-column justify-content-center align-items-center"
        >
          <CustomMetadata
            isEdit={isEdit}
            editData={details}
            customMetadataMaster={customMetadataMaster}
            customPayload={customMetadata}
            setCustomPayload={setCustomMetadata}
            colWidth={'45%'}
          />
        </div>
      ),
      itemStyle: 'mt-4',
      accordionHeight: '4.6875vw',
      accordionPaddingRight: '1.5rem',
    },
    {
      title: 'ADD CONTENT PARTNER',
      description: 'Add content partners to this content.',
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5', padding: '0.8rem 5rem 2rem 1rem' }}
          className="py-3 pb-5 d-flex flex-column justify-content-center align-items-center"
        >
          <div className="w-100">
            <h6 style={{ fontSize: '0.85vw' }} className=" text-left">
              Content Partners
            </h6>
            <div>
              <CustomMultiSelectValues
                selectedValue={contentPartner}
                optionsData={contentPartnerMaster}
                onChange={setContentPartner}
                dropDownlabelKey="email_id"
                tileLabelKey="name"
              />
            </div>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
      accordionHeight: '4.6875vw',
      accordionPaddingRight: '1.5rem',
    },
  ]

  return (
    <CCard
      style={{ minHeight: '70vh', padding: '0 4.18vw' }}
      className="d-flex justify-content-between"
    >
      <div style={{ marginTop: '1.77vw', height: '70vh' }} className=" static-scrollbar-class">
        <div className=" flex flex-column justify-content-center align-items-center w-100">
          <CustomAccordion
            items={accordionItems}
            styles={''}
            titleTextStyle={{
              fontSize: '1.5625vw',
              fontWeight: 600,
            }}
          />
        </div>
      </div>
      <div className=" d-flex justify-content-end pb-3 mx-4">
        <CButton
          style={{ color: 'black', border: '1px solid #bdbdbd' }}
          className="mx-4 bg-white rounded-1 btn-focus-none"
          onClick={() => cancelModal(true)}
        >
          Cancel
        </CButton>
        <CButton
          style={{ backgroundColor: '#20211c' }}
          className="px-3 rounded-1 btn-focus-none"
          onClick={handleSave}
        >
          Save & Next
        </CButton>
      </div>
    </CCard>
  )
}

export default Setting
